<template>
    <main>
        <div class="bax-section bax-select-patient-wrap">
            <div class="container">
                <div class="bax-bg bax-bg-foot-link bax-create-patient">
                    <div class="bax-form-wrapper">
                        <form>
                            <div class="bax-start-order">
                                <div class="bax-section-title">
                                    <h2>Upload a bulk order</h2>
                                </div>
                                <div class="bax-single-content">
                                    <h4>File Information</h4>
                                    <p>Import CSV file by using the file import function below.</p>
                                    <p>Customize your imported order by mapping file headers, applying keyword substitutions and creating customer preference rules.</p>
                                    <p>Customization can be completed during the ordering process or managed in the Customer Preference Wizard.</p>
                                </div>
                                <div class="bax-cta-block">
                                    <a href="/files/Baxter_BOLT_csv_sample.csv" class="bax-btn bax-btn-bordered bax-btn-bordered-blue"><i class="icon-download"></i> Download template</a>
                                </div>
                                <div class="bax-cta-block" v-if="csvPreferencesVisible">
                                    <p>Manage your preferences :<BR /><BR /></p>
                                    <input type="button" value="Open the Customer Preference Wizard" class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0" @click="$emit('go_defaults')">
                                </div>
                            </div>
                            <div class="bax-divider"></div>
                            <div class="bax-upload-wrap">
                                <div class="bax-section-title">
                                    <h4>Upload your file</h4>
                                </div>
                                <div class="bax-custom-fileupload">
                                    <div @click="$refs.file.click()" class="bax-fileupload d-flex flex-wrap align-items-center justify-content-center">
                                        <div class="text-center w-100">
                                            <i class="icon-cloud-upload"></i>
                                            <p>Click to browse your file <span>(.csv)</span></p>
                                        </div>
                                    </div>
                                    <input type="file" ref="file" style="display: none" v-on:change="uploadFileChange()">
                                </div>
                                <div class="bax-custom-fileupload-filelist" v-if="csvFile">
                                    <p><strong>File to be uploaded : </strong>{{ csvFile.name }}</p>
                                    <p><strong>File type :</strong>
                                        <select name="file_type" v-model="fileType">
                                            <option value="1">[NEW]</option>
                                            <option v-for="option in fileTypes" :value="option.id" v-bind:key="option.id" :selected="fileType == option.id">
                                                {{ option.name }}
                                            </option>
                                        </select>
                                    </p>
                                </div>
                            </div>
                            <div class="bax-cta-block d-md-flex">
                                <input type="button" value="Continue" class="bax-btn bax-btn-blue ml-auto mt-3 mt-md-0" :disabled="!csvFile || !fileType" @click.prevent="uploadFileSubmit">
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>


<script>
    import CsvService from '@/core/api/csv/csv.service3';
    import csvMixin from './csvMixin';

    export default {
        name: 'Stage1',
        mixins: [csvMixin],
        props: [],
        data() {
            return {
                csvFile: null,
                csvPreferencesVisible: false,
                csvFileUploaded: null,
                stage: 1,
                fileTypes: false,
                fileType: false,
            };
        },
        created() {
            this.fileTypesLoad();
            this.csvPreferencesVisible = (this.$store.state.auth.user.checkPref('CSV Import Preferences'));
        },
        methods: {
            fileTypesLoad() {
                CsvService.fetchFileTypes(1)
                    .then(async (res) => {
                        this.fileTypes = (res.data.file_types);
                    });
            },
            uploadFileChange() {
                const csvFiles = this.$refs.file.files;
                [this.csvFile] = csvFiles;
            },
            uploadFileSubmit() {
                const file = document.querySelector('input[type=file]').files[0];
                const reader = new FileReader();
               // let uploadId = false;
                let rawImg;
                reader.onloadend = () => {
                    rawImg = reader.result;

                    const data = {
                        file: rawImg,
                        filename: this.csvFile.name,
                        fileType: this.fileType,
                    };
                    CsvService.uploadCsv(data)
                        .then(async (res) => {
                            this.$emit('upload_code_set', res.data.upload_code);
                            this.$emit('waiting_set', 'Uploading file');
                        });
                };

                reader.readAsDataURL(file);
            },
        },
    };
</script>

